module.exports = __webpack_public_path__ + "static/assets/9ce2c5a1bc0cf8b0c3a5770aaa1c4315.png";